/* *** *** *** scrollTop : starts *** *** *** */
$(window).scroll(function() {
  if ($(window).scrollTop() > 100) {
    $('.arrow-up').show();
  } else {
    $('.arrow-up').hide();
  }

  //"dynamic anchors" helper inits
  scrollChecker();
});

$(document).ready(function() {
  effectsListing.vAdaptiveAsideMenu();

  $('#aside-nav li a').click(function(e) {
    dynamicAnchors.asideClicked(e);
  });
});

$('.arrow-up').click(function() {
  $('html, body').scrollTop(0);
});
/* *** *** *** scrollTop : ends *** *** *** */

/* *** *** *** clear text : starts *** *** *** */
var lettersMap = {
  "а": "a",
  "б": "b",
  "в": "v",
  "ґ": "g",
  "г": "g",
  "д": "d",
  "е": "e",
  "ё": "e",
  "є": "ye",
  "ж": "zh",
  "з": "z",
  "и": "i",
  "і": "i",
  "ї": "yi",
  "й": "i",
  "к": "k",
  "л": "l",
  "м": "m",
  "н": "n",
  "о": "o",
  "п": "p",
  "р": "r",
  "с": "s",
  "т": "t",
  "у": "u",
  "ф": "f",
  "х": "h",
  "ц": "c",
  "ч": "ch",
  "ш": "sh",
  "щ": "sh",
  "ъ": "",
  "ы": "y",
  "ь": "",
  "э": "e",
  "ю": "yu",
  "я": "ya"
};

function clearText(str) {
  var cleanString = str.toLowerCase().split(" ").join("_").replace(/[^A-Za-zА-Яа-яЁё_0-9-]/g, "");
  var translitedString = '';

  for (var i = 0; i < cleanString.length; i++) {
    if (lettersMap[cleanString[i]]) {
      translitedString += lettersMap[cleanString[i]];
    } else if (lettersMap[cleanString[i]] === '') {
      translitedString += '';
    } else {
      translitedString += cleanString[i];
    }
  }

  return translitedString;
}
/* *** *** *** clear text : ends *** *** *** */

/* *** *** *** dynamic anchors : starts *** *** *** */
var dynamicAnchors = {

  getHeaders: function() {
    var self = this;
    $('.create-anchor').each(function() {
      self.isSeparateCheck($(this));
    });
    this.findCurrentHash();
  },

  getText: function(htmlNode) {
    return htmlNode.text();
  },

  getHash: function(htmlNode) {
    return htmlNode = clearText(this.getText(htmlNode));
  },

  createAnchor: function(htmlNode, parent) {
    var currentAnchor = '<a class="dynamic-anchor" title="' + this.getText(htmlNode) + '" name="' + this.getHash(htmlNode) + '" href="#' + this.getHash(htmlNode) + '"></a>';

    if (parent) {
      return currentAnchor, parent;
    } else {
      return currentAnchor;
    }
  },

  isSeparateCheck: function(htmlNode) {
    if (htmlNode.hasClass('separate')) {
      this.drawAnchor(htmlNode);
    } else {
      this.drawAnchor(htmlNode, true);
    }
  },

  drawAnchor: function(htmlNode, parent) {
    var getLink;
    getLink = this.createAnchor(htmlNode);
    $(htmlNode).prepend(getLink);

    if (parent) {
      this.setNameForScrollSpy(htmlNode);
      this.drawAside(htmlNode);
    }
  },

  getParent: function(htmlNode) {
    return htmlNode.parent();
  },

  setNameForScrollSpy: function(htmlNode) {
    htmlNode.parent().attr('id', this.getHash(htmlNode));
  },

  drawAside: function(htmlNode) {
    var listItem = '<li><a href="#' + this.getHash(htmlNode) + '">' + this.getText(htmlNode) + '</a></li>';
    $('#aside-nav').append(listItem);
  },

  findCurrentHash: function() {
    var locHash = window.location.hash;

    if ($('#aside-nav li').length) {
      
      $('#aside-nav li a').find('[href="'+ locHash +'"]').parent().addClass('active');
    }
  },

  asideClicked: function(e) {
    $('#aside-nav li').removeClass('active');
    $(e.target).parent().addClass('active');
  }
};

/* *** *** *** dynamic anchors : ends *** *** *** */

/* *** *** *** dynamic nav for filters page : start *** *** *** */

var effectsListing = {
  getElementsArray: function(selector, type) {
    var objectsCollection = {
      selectors: $(selector),
      type: type
    };
    this.categoryAnchors(objectsCollection);
    return objectsCollection;
  },

  createAnchor: function(element, link) {
    $(element).prepend('<a class="dynamic-anchor" id="' +
      link +
      '" href="#' +
      link +
      '"></a>');
  },

  categoryAnchors: function(elementsArray) {
    $(elementsArray.selectors).each(function(i, elem) {
      var getCategoryHeader = $(elem).find('h2')
      var categoryName = getCategoryHeader.text();
      var categoryLink = getCategoryHeader.attr('data-title');
      effectsListing.createAnchor(getCategoryHeader, categoryLink);
      $('#effects_list').append('<h2><a href="#' +
        categoryLink +
        '">' +
        categoryName +
        '</a></h2>');

      effectsListing.basicAnchors(elementsArray, elem);
    });
  },

  basicAnchors: function(elementsArray, section) {
    var headers = $(section).find('h3');

    $('#effects_list').append('<ul class="effects_cat__listing"></ul>');
    $(headers).each(function(i, elem) {
      var link;
      if (elementsArray.type === 'filter') {
        link = $(elem).find('.js-get-link').text();
      } else {
        link = $(elem).text();
      }
      link = clearText(link);
      var anchorHeader = $(elem).text();
      effectsListing.createAnchor($(elem), link);
      $('#effects_list .effects_cat__listing:last-child').append('<li><a href="#' +
        link +
        '">' +
        anchorHeader +
        '</a></li>');
    });
  },

  vAdaptiveAsideMenu: function() {
    var asideNavOffsetTop = 132;
    var rightNavHeight = $('.nav-block__trigger__hack').height() + asideNavOffsetTop;
    var paddingsToFix = 20;

    if (($(window).height() <= rightNavHeight) && ($(window).width() >= 923)) {
      $('.nav-block__trigger__hack').css('height', $(window).height() - asideNavOffsetTop);
    } else if (($(window).height() <= rightNavHeight) && ($(window).width() < 923)) {
      $('.nav-block__trigger__hack').css('height', $(window).height() - paddingsToFix);
    } else {
      $('.nav-block__trigger__hack').css('height', 'auto');
    }
  }

};

/* *** *** *** dynamic nav for filters page : end *** *** *** */

/* *** *** *** dynamic nav for faq page : start *** *** *** */
function faqListing(toIterate, target, placingNavItems) {

  var faqMainList = [];

  $(toIterate).each(function() {
    var faqLocalList = {};
    faqLocalList.itemText = [];
    faqLocalList.itemLink = [];

    var getSource = $(this).find(target).text();
    var getLink = clearText(getSource);

    $(this).find(target).prepend('<a class="dynamic-anchor" id="' + getLink + '" href="#' + getLink + '"></a>');

    faqLocalList.itemText.push(getSource);
    faqLocalList.itemLink.push(getLink);

    faqMainList.push(faqLocalList);

  });

  for (i = 0; i < faqMainList.length; i++) {
    $(placingNavItems).append('<li><a href="#' + faqMainList[i].itemLink + '">' + faqMainList[i].itemText + '</a></li>');
  }

}
/* *** *** *** dynamic nav for faq page : end *** *** *** */

/* *** *** *** dynamic anchors : responsive feature : starts *** *** *** */
$('.nav-block__trigger, .overlay-blind').click(function() {
  $('.nav-block.affix, body').toggleClass('affix--shown');
});

//reset classes, inits on event Scroll
function scrollChecker() {
  if (!$('.nav-block').hasClass('affix')) {
    $('.nav-block, body').removeClass('affix--shown');
  }
}

$(window).resize(function() {
  if ($(window).width() > 992) {
    $('.nav-block, body').removeClass('affix--shown');
  }

  effectsListing.vAdaptiveAsideMenu();
});
/* *** *** *** dynamic anchors : responsive feature : ends *** *** *** */

/* *** *** *** dynamic nav : window location hash case : start *** *** *** */
var path = window.location.pathname;
var pageName = path.substring(1);
if (path) {
  $('#general-nav, .develop_list').find('a[href="' + pageName + '"]').parent().addClass('active');
}


/* *** *** *** dynamic nav : window location hash case : end *** *** *** */

/* *** *** *** aside nav responsive : start *** *** *** */
$(window).resize(function() {
  asideNavOverflow();
});

function asideNavOverflow() {

  var getWindowHeight = $(window).height();
  getWindowHeight = getWindowHeight - 70;

}
/* *** *** *** aside nav responsive : end *** *** *** */

/* *** *** *** sticky wide nav : start *** *** *** */
function wideNavSticky() {
  var getScrollOffset = $('#general-nav').outerHeight(true) + $('.wide-nav').outerHeight(true);

  $('.wide-nav_wrapper').css('height', $('.wide-nav').outerHeight(true));

  $(window).scroll(function() {
    if ($(this).scrollTop() >= getScrollOffset) {
      $('body').addClass('wide-nav--fixed');
    } else {
      $('body').removeClass('wide-nav--fixed');
    }
  });

  $('.show-wide-menu-fixed').click(function() {
    $('body.wide-nav--fixed').addClass('wide-nav-fixed--shown');
  });

  $('.widenav_close-x, .effects-popup-blinder').click(function() {
    $('body.wide-nav--fixed').removeClass('wide-nav-fixed--shown');
  });

  $(document).on('keyup', function(evt) {
    if (evt.keyCode == 27) {
      $('body.wide-nav--fixed').removeClass('wide-nav-fixed--shown');
    }
  });

  $('.wide-nav a').click(function() {
    $('body.wide-nav--fixed').removeClass('wide-nav-fixed--shown');
  });

}
/* *** *** *** sticky wide nav : end *** *** *** */

/* *** *** *** slide-vertical : start *** *** *** */
$('.slide-vertical-control').click(slideVertical);

function slideVertical() {
  if ($('.slide-vertical-content').hasClass('isHidden')) {
    $('.slide-vertical-content').removeClass('isHidden').addClass('isShown');
    $('.slide-vertical-content').slideDown();
    $('.slide-vertical-control').text('Скрыть список фильтров');
  } else {
    $('.slide-vertical-content').removeClass('isShown').addClass('isHidden');
    $('.slide-vertical-content').slideUp();
    $('.slide-vertical-control').text('Показать список фильтров');
  }

  $('html, body').animate({
    scrollTop: $('.ofsset-top-h').offset().top
  });
}
/* *** *** *** slide-vertical : end *** *** *** */

/* *** *** *** rotator : start *** *** *** */
$('.rotator__item').click(rotator);

function rotator() {
  var clickedPreview = $(this);
  clickedPreview.addClass('selected').siblings().removeClass('selected');
  var clickedindex = clickedPreview.index();
  var currentRotator = $(this).parent().parent();
  $(currentRotator).find('.rotator__view img:eq(' + clickedindex + ')').siblings().fadeOut('slow');
  $(currentRotator).find('.rotator__view img:eq(' + clickedindex + ')').fadeIn('slow');
}
/* *** *** *** rotator : end *** *** *** */

/* locals magic : start */
function localisation() {
  var url = window.location;
  var address = url.hostname;
  var local = address.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
  local = local.split('.', 1);

  var ru = $('.lang-chooser #ru');
  var en = $('.lang-chooser #en');

  //russian
  if (local == 'tool') {
    ru.addClass('active');
  }
  //eng
  else if (local == 'en') {
    en.addClass('active');
  }
  en.attr('href', 'http://en.tool.ws.pho.to' + url.pathname);
  ru.attr('href', 'http://tool.ws.pho.to' + url.pathname);
}
/* locals magic : end */


/* hashes checket : fake function */
function hashesChecker() {
  return false;
}
/* hashes checket : fake function */